import React from "react";
import { Tooltip, Input, Button } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { FaMinus } from "react-icons/fa";
import { AiOutlineLike, AiOutlineDislike } from "react-icons/ai";

const SiteNameFilterDropdown = ({
  setSelectedKeys,
  selectedKeys,
  confirm,
  clearFilters,
  siteNames,
}) => {
  const [searchTerm, setSearchTerm] = React.useState("");

  const filteredSiteNames = siteNames.filter((name) =>
    name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div style={{ padding: 8 }}>
      <Input
        placeholder={`Search Site Name`}
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        style={{ marginBottom: 8, display: "block" }}
      />
      <div style={{ maxHeight: 200, overflowY: "auto", marginBottom: 8 }}>
        {filteredSiteNames.map((name) => (
          <div key={name}>
            <input
              type="checkbox"
              checked={selectedKeys.includes(name)}
              onChange={(e) => {
                const newSelectedKeys = e.target.checked
                  ? [...selectedKeys, name]
                  : selectedKeys.filter((key) => key !== name);
                setSelectedKeys(newSelectedKeys);
              }}
              style={{ marginRight: 8 }}
            />
            {name}
          </div>
        ))}
      </div>
      <Button
        type="primary"
        onClick={() => confirm()}
        size="small"
        style={{ width: 90, marginRight: 8, backgroundColor: "blue" }}
      >
        OK
      </Button>
      <Button
        onClick={() => {
          clearFilters();
          setSelectedKeys([]);
        }}
        size="small"
        style={{ width: 90 }}
      >
        Reset
      </Button>
    </div>
  );
};

export const getColumnsDataComplex = (siteNames = [], pagination = {current:1, pageSize:10}) => [
  {
    title: "S.No.",
    key: "serial",
    render: (_text, _record, index) =>
      (pagination.current - 1) * pagination.pageSize + index + 1,

    // sorter: (a, b) => a._serial - b._serial,
    // sortDirections: ['ascend', 'descend'],
    width: 100,
  },
  {
    title: "Created At",
    dataIndex: "created_at",
    key: "created_at",
    render: (text) => new Date(text).toLocaleDateString(),
    sorter: (a, b) => new Date(b.created_at) - new Date(a.created_at),
  },
  // {
  //   title: 'Session ID',
  //   dataIndex: 'session_id',
  //   key: 'session_id',
  //   sorter: (a, b) => a.session_id.localeCompare(b.session_id),
  // },
  {
    title: "Question",
    dataIndex: "question",
    key: "question",
    sorter: (a, b) => a.question.localeCompare(b.question),
  },
  {
    title: "Answer",
    dataIndex: "answer",
    key: "answer",
    render: (text) => {
      const plain = String(text || "").replace(/<[^>]+>/g, "");
      const truncate = (s, n = 300) =>
        s.length > n ? `${s.slice(0, n)}...` : s;
      return (
        <Tooltip
          title={
            <div style={{ whiteSpace: "normal", wordBreak: "break-word" }}>
              {truncate(plain, 300)}
            </div>
          }
          overlayInnerStyle={{
            maxWidth: 400,
            whiteSpace: "normal",
            wordBreak: "break-word",
          }}
        >
          <span
            style={{
              display: "inline-block",
              maxWidth: "500px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {plain}
          </span>
        </Tooltip>
      );
    },
    sorter: (a, b) => a.answer.localeCompare(b.answer),
    width: 500,
  },

  {
    title: "Site Name",
    dataIndex: "site_name",
    key: "site_name",
    sorter: (a, b) => a.site_name.localeCompare(b.site_name),
    filterDropdown: (props) => <SiteNameFilterDropdown {...props} siteNames={siteNames} />,
    filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
    onFilter: (value, record) => record.site_name.includes(value),
  },
  // {
  //   title: "IP Address",
  //   dataIndex: "ip_address",
  //   key: "ip_address",
  //   sorter: (a, b) => a.ip_address.localeCompare(b.ip_address),
  // },
  {
    title: "Rating",
    dataIndex: "rating",
    key: "rating",
    render: (rating) => {
      if (rating === 1) {
        return <AiOutlineLike color="green" fontSize={20} />;
      }
      if (rating === -1) {
        return <AiOutlineDislike color="red" fontSize={20} />;
      }
      return <FaMinus color="gray" />;
    },
    sorter: (a, b) => a.rating - b.rating,
  },
  
];
